import InputField from "@/components/form/InputField";
import CheckboxField from "@/components/form/CheckboxField";
import * as Yup from "yup";

export const inputValidationSchema = {
  options: Yup.object()
    .nullable()
    .shape({
      input: Yup.object().nullable().shape({
        addon_before: Yup.string().nullable(),
        addon_after: Yup.string().nullable(),
        placeholder: Yup.string().nullable(),
        masked: Yup.boolean().nullable(),
      }),
    }),
};

export default function InputDisplayOptions() {
  return (
    <div>
      <div className="flex gap-4">
        <div className="w-1/2">
          <InputField name="options.input.addon_before" label="Addon before" />
        </div>
        <div className="w-1/2">
          <InputField name="options.input.addon_after" label="Addon after" />
        </div>
      </div>
      <InputField name="options.input.placeholder" label="Placeholder" />
      <CheckboxField
        name="options.input.masked"
        label="Masked"
        description="Mask the input value (for passwords, etc.)"
      />
    </div>
  );
}
